import {useMutation} from 'react-query';
import {countriesService} from '../../../../shared/services/configuration/countries';

export const useGetCountryById = () => {
  return useMutation((countryId: string) => {
    return countriesService.getCountryByID(countryId);
  });
};
